import * as messages from "./exports";
export default messages;
